export default __webpack_public_path__ + "static/media/cabourg22.5054cc63.jpg";